import { Button, Dialog, Heading, Text } from "@rshbintech.dboul/core-ui";
import { AccountRemoved as AccountRemovedImage } from "@rshbintech.dboul/images";
import {
  BulkSignOrchestratorApiTypes,
  bulkSignOrchestratorApi,
} from "@rshbintech.dboul/http";
import { UNKNOWN_ERROR } from "../constants";
import {
  CLOSE_BUTTON,
  CONTINUE_BUTTON,
  WARNING_ANNOTATION,
  WARNING_TITLE,
} from "./constants";
import { WarningDialogProps } from "./types";
import styles from "./styles.scss";

export const WarningDialog = ({
  taskId,
  isOpened,
  closeOverlay,
  closeDialog,
  onError,
}: WarningDialogProps) => {
  const handleClose = async () => {
    try {
      await bulkSignOrchestratorApi.api.cancelSignTask(taskId);
    } catch (error) {
      const isErrorInfo = (
        error: unknown
      ): error is BulkSignOrchestratorApiTypes.ErrorInfo =>
        error instanceof Object && "message" in error;

      if (isErrorInfo(error)) {
        onError?.(error.message);
      } else if (error && typeof error === "string") {
        onError?.(error);
      } else {
        onError?.(UNKNOWN_ERROR);
      }
    }

    closeDialog();
    closeOverlay();
  };

  const handleContinue = () => {
    closeDialog();
  };

  return (
    <Dialog opened={isOpened} onClose={handleContinue}>
      <div className={styles.container}>
        <AccountRemovedImage width={128} height={128} />
        <Heading className={styles.title} level={4}>
          {WARNING_TITLE}
        </Heading>
        <Text className={styles.annotation} size="medium">
          {WARNING_ANNOTATION}
        </Text>
        <div className={styles["button-container"]}>
          <Button type="outline-danger" onClick={handleClose} htmlType="button">
            {CLOSE_BUTTON}
          </Button>
          <Button
            className={styles["continue-button"]}
            onClick={handleContinue}
            htmlType="button"
          >
            {CONTINUE_BUTTON}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
